module.exports = __webpack_public_path__ + "public/img/situationD.9d2daf3b.png";